import React from 'react'
import {Link} from 'react-router-dom' // If using React Router
import {IconButton, Typography, useMediaQuery, useTheme} from '@mui/material'
import {makeStyles} from '@mui/styles'
import './styles.css'

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: '-4rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '1rem',
    curser: 'pointer',
  },
}))

const DynamicIcon = ({
  icon,
  svg,
  png,
  title,
  link,
}: {
  icon?: any
  svg?: string
  png?: any
  title?: string
  link?: string
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const isXs = useMediaQuery(theme.breakpoints.down('xs'))
  const isSm = useMediaQuery(theme.breakpoints.down('sm'))
  const isMd = useMediaQuery(theme.breakpoints.down('md'))
  return (
    <div
      className={classes.container}
      style={{marginBottom: '10px', marginRight: isXs || isSm || isMd ? '0px' : '70px'}}
    >
      <IconButton component={Link} to={link} color='primary'>
        <div className='icons'>
          <div className='icon'>
            <div className='bg'></div>
            <div className='glass'>
              <i>
                {icon && React.createElement(icon, {fontSize: '30px'})}
                {svg && <span dangerouslySetInnerHTML={{__html: svg}} />}
                {png && <img src={png} alt={title} style={{width: '60px', height: '60px'}} />}
              </i>
            </div>
          </div>
        </div>
      </IconButton>
      <Typography
        variant='subtitle1'
        fontFamily='Poppins'
        fontWeight={500}
        fontSize={18}
        align='center'
      >
        {title}
      </Typography>
    </div>
  )
}

export default DynamicIcon
